import { forwardRef, ComponentType, ReactNode } from 'react'

import { humanizeKey, getComponentName } from 'peach/helpers'

import ItemLabel from './ItemLabel'

type WithLabelProps = {
  formKey?: string
  label?: string
  note?: string
  placeholder?: string
  bare?: boolean
  required?: boolean
  meta?: any
  isChanged?: boolean
  isFocused?: boolean
  recentlyActive?: boolean
  tooltip?: string
  children?: ReactNode
}

type WrappedComponentProps = {
  placeholder?: string
  formKey?: string
  label?: string
}

const withLabel = (Component: ComponentType<any>) => {
  const Label = forwardRef<any, WithLabelProps & { [key: string]: any }>(
    (props, ref) => {
      const {
        formKey,
        label,
        note,
        placeholder,
        bare,
        required,
        meta,
        isChanged,
        isFocused,
        recentlyActive,
        tooltip,
        ...rest
      } = props

      const displayLabel = label || placeholder || humanizeKey(formKey)
      const displayPlaceholder = placeholder || label || humanizeKey(formKey)

      const renderProps: WrappedComponentProps & { ref: any } = {
        placeholder: displayPlaceholder,
        formKey: formKey,
        ref,
      }

      return bare ? (
        <Component {...renderProps} label={displayLabel} {...rest} />
      ) : (
        <ItemLabel
          label={displayLabel}
          meta={meta}
          note={note}
          required={required}
          tooltip={tooltip}
        >
          <Component {...renderProps} label={displayLabel} {...rest} />
        </ItemLabel>
      )
    },
  )

  Label.displayName = getComponentName(Component, 'withLabel')

  return Label
}

export default withLabel
